import React, { useState, useEffect } from "react";
import PostWrapper from "../Components/Post/PostWrapper";
import { Helmet } from "react-helmet-async";
import { getBlogPosts } from "../utils/contentfulConfig";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visiblePosts, setVisiblePosts] = useState(6);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const blogPosts = await getBlogPosts();
        setPosts(blogPosts);
      } catch (err) {
        console.error("Failed to fetch blog posts:", err);
        setError("Failed to load blog posts. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading blog posts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        {error}
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Read Our Expert Tips, Guides & Dental Blogs</title>
        <meta
          name="description"
          content="Explore expert dental tips, guides, and blogs created to help you maintain a healthy and confident smile. Read our latest articles now."
        />
      </Helmet>
      <div className="st-height-b125 st-height-lg-b80" id="home"></div>

      {posts.length > 0 ? (
        <>
          <PostWrapper data={posts.slice(0, visiblePosts)} />
          {posts.length > visiblePosts && (
            <div className="text-center py-5 df-center">
              <button
                onClick={() => {
                  setLoadingMore(true);
                  setTimeout(() => {
                    setVisiblePosts((prev) => prev + 6);
                    setLoadingMore(false);
                  }, 500);
                }}
                className="st-btn st-style1 st-size-medium st-color1"
                disabled={loadingMore}
              >
                {loadingMore ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Loading...
                  </>
                ) : (
                  "Load More"
                )}
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-5">
          <p>No blog posts found.</p>
        </div>
      )}
      <div className="st-height-b125 st-height-lg-b80" id="home"></div>
    </>
  );
}
